// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import Component from "gia/Component";
// import eventbus from "gia/eventbus"; // NOT NEEDED ATM

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// —————————————————————————————————————— INITIALIZATION F() —————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// import { get_viewportState } from "../../../assets/js/init/init_viewportState"; // NOT NEEDED ATM
import init_splide from "./init/init_splide";

// ——————————————————————————— EVENT/EVENTBUS/STATE CHANGE HANDLERS/API ——————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// Options with case-sensitive keys that are not to be
// automatically extracted from the options arg. but be
// assigned to an option key manually to preserve its case
// (Kirby CMS converts all fields/option keys to lowercase)
// (see constructor).

const manualOptionKeys = ["optionkey"];

//  Default values for manually extracted options
//  (see constructor, in case specific option has not been provided
//  in comp. config.).

const defaultOptions = {
  optionkey: { foo: "bar" },
};

// Default log styles

const defaultLogStyles = {
  default: "#6682d6",
  action: "#c7d0ff",
  event: "#97a5ce",
  warning: "#ffaf00",
  error: "#ff3232",
  success: "#00c853",
};

// ——————————————————————————————————————— COMP. DEFINITION ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default class ImgMarquee extends Component {
  /////////// Constructor ////////////
  ////////////////////////////////////

  constructor(el, options) {
    super(el);

    ////// DOM refs. ///////
    ////////////////////////

    this.ref = {
      wrpr_slides: null,
      slides: [],
    };

    /////// Options ////////
    ////////////////////////

    // Get options not to be manually extracted from the options arg...
    const autoOptions = {};
    for (const key in options) if (!manualOptionKeys.includes(key)) autoOptions[key] = options[key];

    this.options = {
      name: "ImgMarquee",
      // optionKey: options.optionkey,
      ...autoOptions,
      //////
      logs: false,
      logStyles: defaultLogStyles,
    };

    ////// Utilities ///////
    ////////////////////////

    // ...

    ////// Init. f() ///////
    ////////////////////////

    this.init_splide = init_splide.bind(this);

    /////// Modules ////////
    ////////////////////////

    this.modules = {
      // ...
    };

    ///////// API //////////
    ////////////////////////

    this.api = {
      // ...
    };

    ////// Event hdl. //////
    ////////////////////////

    // ...

    // Eventbus listeners //
    ////////////////////////

    // ...

    // State-change hdls. //
    ////////////////////////

    // ...

    // Custom event hdls. //
    ////////////////////////

    // ...

    /// Pre-mount init. ////
    ////////////////////////

    // ...
  }

  ////////////// Mount ///////////////
  ////////////////////////////////////

  mount() {
    if (this.options.logs) console.warn("Mounting:", this.options.name);
    this.init();
  }

  ///////////// Unmount //////////////
  ////////////////////////////////////

  unmount() {
    if (this.options.logs) console.warn("Unmounting:", this.options.name);

    // De-registr. ///
    //////////////////

    // Eventbus //
    // ...

    // API //
    // ...
  }

  ////////////// Init. ///////////////
  ////////////////////////////////////

  /// Base init. ///
  //////////////////

  init() {
    // this.init_states(); // NOT NEEDED ATM //
    // this.init_eventbus(); // NOT NEEDED ATM //
    // this.init_events(); // NOT NEEDED ATM //

    this.init_splide();
  }

  // States init. //
  //////////////////

  // NOT NEEDED ATM //
  // init_states() {
  //   this.setState({ features: { mouse: window.matchMedia("(pointer:fine)").matches } });
  // }

  // Events init. //
  //////////////////

  // NOT NEEDED ATM //
  // init_events() {
  //   // Listener registration //
  //   // ...

  //   // ...
  // }

  // Eventb. init. //
  ///////////////////

  // NOT NEEDED ATM //
  // init_eventbus() {
  //   if (this.options.logs) console.warn("Eventbus init.", this.options.name);

  //   // Listener registration //
  //   // ...

  //   // API call registration //
  //   // ...

  // }

  ///////// State management /////////
  ////////////////////////////////////

  stateChange(CHANGES) {
    if (this.options.logs) console.log("State change:", CHANGES);
  }
}

// export default NewComponent;
